<template lang="pug">
v-layout.px-3(column)
  v-layout(column)
    v-card.pa-2
      v-btn.my-0(:disabled="loading" icon @click="back")
        v-icon arrow_back    
      v-list.py-0
        v-list-tile-action
          v-list-tile-action-text {{format_date(variables.created)}}
          v-icon(color="grey lighten-1")
        v-list-tile(avatar="" ripple="" style="margin-bottom:30px;")
          v-list-tile-content
            v-list-tile-title.font-weight-medium(v-if="variables.title || variables.titleKaz") {{locale === 'kk' ? variables.titleKaz.value : variables.title.value}}
            v-list-tile-sub-title(style="overflow:visible; white-space: normal;")
              v-flex(xs12 sm12)
                div(style="white-space: pre-wrap;") {{locale === 'kk' ? variables.contentKaz.value : variables.content.value}}
              v-flex(v-if="variables.photo.value && variables.photo.value.length > 0" xs12 sm12 style="text-align: center;")
                wf-media-viewer(id="news-process-photos" :label="$tf('drawer.news.picture')" :items="variables.photo.value")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import minioAPI from '@/services/minio'
import dictionariesAPI from '@/services/dictionaries'
import router from '@/router'
import { getLocale } from '@/i18n'

export default {
  name: 'NewsController',

  props: ['newsId'],

  provide() {
    const that = this
    return {
      ctrl: {
        get(name, alt) {
          return that.variables[name] ? that.variables[name].value : alt
        },
        getDownloadUrls(files) {
          if (files) {
            return minioAPI.presignedGetObjectUrls(files)
          }
          return null
        },
        getDictionary(dictionary, payload) {
          return dictionariesAPI.request(dictionary, payload)
        },
        getСancelableDictionary(dictionary, payload) {
          return dictionariesAPI.cancelableRequest(dictionary, payload)
        },
        getCurrentUser() {
          return Object.assign(that.profile, { groups: that.groups, locale: that.locale })
        },
        getCurrentTask() {
          return that.task
        },
        t(key) {
          return that.$tf(`${that.task.processDefinitionId.split(':')[0]}.${key}`)
        },
        routerPush(arg) {
          return that.$router.push(arg)
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      task: 'task/task',
      variables: 'task/variables',
      submitMode: 'task/submitMode',
      loading: 'tools/loading',
      profile: 'auth/profile',
      groups: 'auth/groups',
      locale: 'tools/locale',
    }),
    locale() {
      return getLocale()
    },
  },

  methods: {
    ...mapActions({
      getTask: 'task/getTask',
      showConfirm: 'tools/showConfirm',
      setSnackbar: 'tools/setSnackbar',
    }),
    format_date(value) { // 2022-07-18T15:40:56.994Z
      if (value) {
        return this.$moment(value).format('DD.MM.YYYY HH:mm')
      }
    },
    back() {
      router.push('/news-list')
    },
  },
}
</script>

<style lang="stylus"></style>



// WEBPACK FOOTER //
// src/components/news/NewsController.vue